Vue.component('switcher', {
    props: {
        tabs: Array
    },
    data() {
        return {
            activeTab: null
        };
    },
    methods: {
        switchTo(index) {
            this.activeTab = index;
        }
    },
    mounted() {
        for (let index in this.tabs) {
            if (this.tabs[index].available) {
                this.activeTab = +index;
                break;
            }
        }
    }
});